import { createWaiver } from "../../api/historyService";

export const useCreateWaiver = (successCallback) => {
    const create = async (data) => {
        try {
            const newRecord = await createWaiver(data);
            if (successCallback)
            {
                successCallback(newRecord);
            }
            return newRecord;
        } catch (error) {
            console.error("Failed to create waiver:", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { create };
};